import { useGuest } from '@/context/guest';
import useQueryString from './useQueryString';

/**
 * Custom hook to determine is invitation or not
 * @return {string}
 */
function useInvitation() {
  const { getQueryValue } = useQueryString();
  const { isRegistered, isLoading } = useGuest();
  const isHaveCode = getQueryValue('code', '');

  // If still loading, and has query params `code`. then force to true
  if (isLoading && isHaveCode) return true;
  // IF loading has finished, then refer to isRegistered always
  return isRegistered;
}

export default useInvitation;